import React, { Component } from "react";
import { Link } from "react-router-dom";
import pr_1 from "../../images/practice/2.jpg";
import pr_2 from "../../images/practice/3.jpg";
import pr_3 from "../../images/practice/4.jpg";

class PracticDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "Real Estate Law", // Default category
    };
  }

  render() {
    const { selectedCategory } = this.state;

    // Define content for each category
    const categoryContent = {
      "Real Estate Law": {
        image: pr_2,
        title: "Real Estate Law",
        description: "We offer Real Estate Including...",
        organizations: [
          "Purchases, Sales and Mortgages for residential transactions.",
          "Purchases, Sales and Mortgages for commercial transactions.",
          "Drafting Agreements of Purchase and Sale – residential and commercial.",
          "Review of Status Certificates for condominium purchases.",
          "Drafting Co-Ownership Agreements and Joint Venture Agreements.",
          "Acting for sophisticated lenders on Private Mortgage Transactions.",
          "Assisting clients with Mortgage Enforcement issues.",
        ],
      },
      "Wills & Estates": {
        image: pr_3,
        title: "Wills & Estates Law",
        description:
          "We offer fixed price Will packages which include drafting Will (including two revisions), Powers of Attorney for Property and Personal Care.",
        organizations: [
          {
            heading: (
              <div style={{ fontSize: "24px", fontWeight: "bold" }}>
                Our Prices for standard wills are:
              </div>
            ),
            details: [
              <p key="singleWill">
                <i>
                  <b>• Single Will Package: $749.00 +HST.</b>
                </i>
              </p>,
              <p key="mirrorWills">
                <i>
                  <b>• For Couples (Mirror Wills): $999.00 +HST.</b>
                </i>
              </p>,
            ],
          },
        ],
      },
      "Corporate Services": {
        image: pr_1,
        title: "Corporate Services",
        description: "We offer Incorporation Packages Including...",
        organizations: [
          "Electronic Minute Book.",
          "Articles & Certificate of Incorporation.",
          "Corporate By-Laws.",
          "Director & Shareholder Resolutions.",
          "Share Subscription & Share Certificates.",
          "Registers & Ledgers.",
          "Government Filing.",
          "3rd Party Fees & Disbursements.",
          "Corporate Name Searches (Pre-Nuans & Nuans).",
          "Business Number/Tax Accounts from CRA.",
          "Form 1 or Form 2 Initial Returns.",
          "Legal Advice & Consultation.",
        ],
        showCheckbox: true,
      },
    };

    const currentCategoryContent = categoryContent[selectedCategory];

    return (
      <div className="practice-details-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12 col-12 p-p">
              <div className="row">
                <div className="col-lg-12 col-md-6 col-12">
                  <div className="field-section">
                    <div className="field-img">
                      <img src={currentCategoryContent.image} alt="" />
                    </div>
                    <div className="field-content">
                      <h3>
                        <span>15</span> Years of Experience
                      </h3>
                      <div className="btns">
                        <div className="btn-style">
                          <Link to="/contact">Contact Us Now</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-6 col-12">
                  <div className="practice-catagory-item">
                    <div className="widget-title">
                      <h3 className="text-left">Category</h3>
                    </div>
                    <div className="practice-section">
                      <ul>
                        <li>
                          <Link
                            to="/practice-details"
                            onClick={() =>
                              this.setState({
                                selectedCategory: "Real Estate Law",
                              })
                            }
                          >
                            Real Estate Law
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/practice-details"
                            onClick={() =>
                              this.setState({
                                selectedCategory: "Wills & Estates",
                              })
                            }
                          >
                            Wills & Estates
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/practice-details"
                            onClick={() =>
                              this.setState({
                                selectedCategory: "Corporate Services",
                              })
                            }
                          >
                            Corporate Services
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-12">
              <div className="practice-section-text">
                <h2>
                  {currentCategoryContent.title}
                  <img
                    src={currentCategoryContent.image}
                    alt=""
                    className="category-image"
                  />
                </h2>
                <h5>{currentCategoryContent.description}</h5>
                {/* Render organizations */}
                {currentCategoryContent.organizations && (
                  <div className="organigation-area">
                    <div className="organaigation-text">
                      <ul>
                        {currentCategoryContent.organizations.map(
                          (org, index) => (
                            <li key={index}>
                              {typeof org === "string" ? (
                                <i
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>
                              ) : null}
                              {typeof org === "string" ? org : org.heading}
                              {typeof org !== "string" && org.details && (
                                <ul>
                                  {org.details.map((detail, detailIndex) => (
                                    <li key={detailIndex}>{detail}</li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ),
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PracticDetails;
